import { styled, Grid as MuiGrid } from "@mui/material";

export const StyledListTools = styled(MuiGrid)(({ theme }) => ({
    position: `relative`,
    width: `100%`,
}));
